// Entrada de la interfaz. Con VITE_API_SIMULADA=si (solo para ver la interfaz sin servidor) las peticiones las contesta
// un servidor simulado EN EL NAVEGADOR, con datos inventados y una franja que lo dice. Sin esa variable, el código del
// simulado ni siquiera entra al paquete (import dinámico detrás de una constante que Vite reemplaza al compilar).
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { FORMATOS_FAMILIA } from '@cotizador/compartido';
import './estilos/tokens.css';
import './estilos/tokens-producto.css';
import './estilos/base.css';
import './estilos/componentes.css';
import './estilos/pantallas.css';
import { App } from './App.tsx';
import { usarTransporte } from './api/cliente.ts';
import { instalarFocoVisible } from './logica/foco-visible.ts';

async function arrancar(): Promise<void> {
  if (import.meta.env.VITE_API_SIMULADA === 'si') {
    const { crearServidorSimulado } = await import('./api/simulado/servidor-simulado.ts');
    const q = new URLSearchParams(window.location.search);
    const como = q.get('como');
    // ?politica=si enciende "vendedor externo edita solo lo suyo" (contrato v2) para verla sin servidor.
    const politica = q.get('politica') === 'si' ? { externo_edita_solo_lo_suyo: true } : undefined;
    // ?formatos=todos: el «generador» con todos los formatos de la familia (por omisión, solo el residencial, como al inicio).
    const formatos = q.get('formatos') === 'todos' ? [...FORMATOS_FAMILIA] : undefined;
    // ?plantilla=sin_desglose (no engloba el precio de una ampliación: el PDF no sale) o ?plantilla=sin_hoja2 (sale sin la hoja 2).
    const plantilla = q.get('plantilla');
    const capacidadesPiezas = plantilla === 'sin_desglose' ? { sin_desglose: false } : plantilla === 'sin_hoja2' ? { ampliacion_baterias: false } : undefined;
    usarTransporte(crearServidorSimulado({ sesionInicial: como, retraso: Number(q.get('retraso') ?? 220), politica, ...(formatos ? { formatos } : {}), ...(capacidadesPiezas ? { capacidadesPiezas } : {}) }), true);
    if (como) {
      q.delete('como');
      q.delete('retraso');
      q.delete('politica');
      q.delete('formatos');
      q.delete('plantilla');
      const resto = q.toString();
      window.history.replaceState(null, '', window.location.pathname + (resto ? `?${resto}` : ''));
    }
  }
  instalarFocoVisible();
  const raiz = document.getElementById('raiz');
  if (!raiz) throw new Error('Falta <div id="raiz"> en index.html');
  createRoot(raiz).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void arrancar();
